<!--列表查看视图-->
<template>
  <div>
    <template v-if="lob==='SI'">
      <tab-local-service ref="tabLocalService" :context="context" :action="action" from="sales" />
    </template>
    <template v-if="lob==='SE'">
      <tab-warehouse-for-se ref="tabWarehouseForSe" :context="context" :action="action" from="sales" />
      <tab-trucking-for-se ref="tabTruckingForSe" :context="context" :action="action" from="sales" style="margin-right: 20px" />
    </template>
    <template v-if="lob==='AE'">
      <tab-warehouse-trucking ref="tabLocalService" :context="context" :action="action" />
    </template>
    <template v-if="lob==='AI'">
      <tab-local-service-for-ai ref="tabLocalService" :context="context" :action="action" />
    </template>
    <template v-if="lob==='RE'||lob==='RI'">
      <tab-local-service ref="tabLocalService" :context="context" :action="action" from="sales" style="margin-right: 20px" />
    </template>
  </div>
</template>

<script>

import { getLoading } from '@/utils/utilBaseElement'

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import tabLocalService from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabLocalService'
import tabLocalServiceForAi from '@/views/cargo/v0/AirImport/components/booking/tabs/tabLocalService'
import tabTruckingForSe from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabTrucking'
import tabWarehouseForSe from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabWarehouse'
import tabWarehouseTrucking from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabWarehouseTrucking' // 空出仓库内装

export default {
  name: 'SalesQueryWarehouseTab',
  components: {
    tabTruckingForSe, tabWarehouseForSe, tabWarehouseTrucking,
    tabLocalService, tabLocalServiceForAi
  },
  props: {
    job: { type: Object, required: true },
    lob: { type: String, required: true, validator: (value) => { return ['AE', 'SE', 'SI', 'RE', 'RI', 'AI', ''].includes(value) } }, // AE SE SI RWE, ''(空字符串）为解决初始化警告问题
    masterFlag: { type: Boolean, required: true },
    context: { type: Object, required: false },
    viewSource: { // 页面请求发起方
      type: String,
      required: false
    }
  },
  data() {
    return {
      loading: false,
      selectTypeNames: TYPE_NAMES,
      action: 'look'
    }
  },
  methods: {
    onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      this.loading = getLoading()
      switch (this.lob) {
        case 'SE': {
          this.$nextTick(() => {
            this.$refs['tabWarehouseForSe'].onShow(row, isRefresh)
            this.$refs['tabTruckingForSe'].onShow(row, isRefresh)
          })
          break
        }
        case 'AE':
        case 'AI':
        case 'RE':
        case 'RI':
        case 'SI': {
          this.$nextTick(() => {
            this.$refs['tabLocalService'].onShow(row, true)
          })
          break
        }
      }
      this.loading.close()
    }
  }
}
</script>

<style lang="scss">
</style>
